import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=1fc8ce04&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=1fc8ce04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc8ce04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fc8ce04')) {
      api.createRecord('1fc8ce04', component.options)
    } else {
      api.reload('1fc8ce04', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=1fc8ce04&scoped=true", function () {
      api.rerender('1fc8ce04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/decorationPage/library/modules/PintuanGoods/Form.vue"
export default component.exports